interface TopicInputListProps {
  topics: string[];
  onChange: (topics: string[]) => void;
}

export function validateTopics(topics: string[]): { topics: string[]; error?: string } {
  const cleaned = topics.map((topic) => topic.trim()).filter(Boolean);
  if (cleaned.length > 20) {
    return { topics: cleaned, error: 'אפשר להוסיף עד 20 נושאים.' };
  }
  if (cleaned.some((topic) => topic.length > 100)) {
    return { topics: cleaned, error: 'כל נושא יכול להכיל עד 100 תווים.' };
  }
  if (new Set(cleaned).size !== cleaned.length) {
    return { topics: cleaned, error: 'כל נושא צריך להופיע פעם אחת בלבד.' };
  }
  return { topics: cleaned };
}

export function TopicInputList({ topics, onChange }: TopicInputListProps) {
  return (
    <fieldset
      data-testid="reconstruction-topics"
      className="space-y-2 rounded-xl border border-slate-200 p-3"
    >
      <legend className="px-1 text-sm font-medium text-slate-700">נושאים (לא חובה)</legend>
      <p className="text-xs text-slate-500">
        הוסיפו כל נושא בשורה נפרדת. לא ניתן לשנות את הנושאים לאחר יצירת השחזור.
      </p>
      {topics.map((topic, index) => (
        <div key={index} className="flex items-center gap-2">
          <input
            type="text"
            value={topic}
            maxLength={100}
            aria-label={`נושא ${index + 1}`}
            data-testid={`reconstruction-topic-input-${index}`}
            onChange={(event) =>
              onChange(topics.map((value, candidateIndex) =>
                candidateIndex === index ? event.target.value : value
              ))
            }
            placeholder="לדוגמה: התפתחות שפה"
            className="min-w-0 flex-1 rounded-xl border border-slate-300 px-3 py-2 text-sm"
          />
          <button
            type="button"
            aria-label={`הסרת נושא ${index + 1}`}
            data-testid={`reconstruction-topic-remove-${index}`}
            onClick={() => onChange(topics.filter((_, candidateIndex) => candidateIndex !== index))}
            className="shrink-0 rounded-lg px-2 py-2 text-sm text-red-600 hover:bg-red-50"
          >
            הסרה
          </button>
        </div>
      ))}
      <button
        type="button"
        data-testid="reconstruction-topic-add"
        onClick={() => onChange([...topics, ''])}
        disabled={topics.length >= 20}
        className="text-sm font-medium text-blue-700 hover:text-blue-800 disabled:cursor-not-allowed disabled:opacity-50"
      >
        + הוספת נושא
      </button>
    </fieldset>
  );
}
